import React, { memo, useEffect, useRef, useState, forwardRef, useMemo, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

//
import {
   addFavSymbol,
   removeFavSymbol,
   showPopupInfo,
   addSummarySymbol,
   removeSummarySymbol,
   getSummarySymbolsFromStorage,
   getFavSymbolsFromStorage,
   getPinnedCodesByTab,
   savePinnedCodesByTab,
   getOrderedCodesByTab,
   saveOrderedCodesByTab,
} from "../redux/actions/sharedActions";

import { formatQtty, formatNumberToM, formatPctChangePrice, isNullOrEmpty } from "../helpers/utils";
import { constTabName } from "../helpers/constData";
import { ReactComponent as RandomEndIcon } from "../assets/fonts/Icon RE.svg";

// import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import { useApiCategoryStock } from "../helpers/apiCategoryStock";
// import { themeAlpine, iconOverrides } from 'ag-grid-community';

// Register all Community features
// ModuleRegistry.registerModules([AllCommunityModule]);

// ===== TABLE DETAIL =====
export default memo(function PriceBoardDetailModeAGGrid(props) {
   // Props var
   const { symbolInfos, tabName, isAutoScroll } = props;

   const tabIsSumary = tabName && tabName === constTabName.TongHop;
   const tabIsFav = tabName && tabName === constTabName.Fav;
   const showRemoveIcon = tabIsSumary || tabIsFav;

   const dispatch = useDispatch();
   const { t } = useTranslation();
   const apiCategoryStock = useApiCategoryStock();

   const summarySymbols = getSummarySymbolsFromStorage();
   const favSymbols = getFavSymbolsFromStorage();
   const orderedCodesByTab = getOrderedCodesByTab(window.location.pathname);
   const pinnedCodesByTab = getPinnedCodesByTab(window.location.pathname);

   // const [priceFlag, setPriceFlag] = useState(true);
   const [pinnedRows, setPinnedRows] = useState([]);

   const refGrid = useRef(null);
   const priceFlag = useRef(true);
   const totalVolFlag = useRef(true);

   const currentCategory = useSelector((state) => state.gShared.currentCategory) ?? [];
   const configShowHideColumn = useSelector((state) => state.gShared.configShowHideColumn);

   const sss = useSelector((state) => state.gSymbol.symbolInfos);
   const { findSymbol } = useSelector(
      (state) => ({
         findSymbol: state.gShared.findSymbol,
      }),
      (prev, next) => {
         return prev.findSymbol.counter === next.findSymbol.counter;
      }
   );

   useEffect(() => {
      if (findSymbol.code && refGrid.current.api) {
         const rowNode = refGrid.current.api.getRowNode(findSymbol.code);
         if (rowNode) {
            refGrid.current.api.ensureIndexVisible(rowNode.rowIndex, "top");
         }
      }
   }, [findSymbol]);

   useEffect(() => {
      if (!isAutoScroll) return;

      const interval = setInterval(() => {
         const bodyViewport = document.querySelector(".ag-body-viewport");
         if (bodyViewport) {
            // Scroll xuống dần
            if (bodyViewport.scrollTop + bodyViewport.clientHeight >= bodyViewport.scrollHeight) {
               bodyViewport.scrollTop = 0; // quay lại đầu nếu đến cuối
            } else {
               bodyViewport.scrollTop += 1;
            }
         }
      }, 50); // mỗi 50ms

      return () => clearInterval(interval);
   }, [isAutoScroll]);

   useEffect(() => {
      const intervalId = setInterval(() => {
         var pinnedCount = refGrid?.current?.api.getPinnedTopRowCount();
         for (let i = 0; i < pinnedCount; i++) {
            var node = refGrid?.current?.api.getPinnedTopRow(i);
            if (!node) {
               continue;
            }
            var newData = sss.find((e) => e.code === node.data.code);
            if (newData.counter !== node.data.counter) {
               node.setData({ ...newData });
               // refGrid?.current?.api.refreshCells({ rowNodes: [node], force: true, suppressFlash: true });
            }
         }
         // refGrid?.current?.api.getRenderedNodes().forEach(node => {
         refGrid?.current?.api.forEachNode((node) => {
            if (!node) {
               return;
            }
            var newData = sss.find((e) => e.code === node.data.code);
            if (newData.counter !== node.data.counter) {
               node.setData({ ...newData });
               // refGrid?.current?.api.refreshCells({ rowNodes: [node], force: true, suppressFlash: true });
            }
         });
         // console.log("getRenderedNodes", refGrid?.current?.api.getRenderedNodes());
         // const rowCount = refGrid?.current?.api.getDisplayedRowCount();
         // for (let i = 0; i < 10; i++) {
         //     const row = Math.floor(Math.random() * rowCount);

         //     const node = refGrid?.current?.api.getDisplayedRowAtIndex(row);
         //     if (!node) {
         //         continue;
         //     }

         //     //
         //     var time = (new Date()).getTime();
         //     var newData = { ...node.data };

         //     if (time % 3 === 0) {
         //         ["bidPrice3", "bidQtty3", "bidPrice2", "bidQtty2", "bidPrice1", "bidQtty1"].forEach(field => {
         //             newData[field] = Math.floor(Math.random() * 10000).toString();
         //             // node.setDataValue(field, newData[field]);
         //         });
         //     }
         //     else if (time % 3 === 1) {
         //         ["offerPrice3", "offerQtty3", "offerPrice2", "offerQtty2", "offerPrice1", "offerQtty1"].forEach(field => {
         //             newData[field] = Math.floor(Math.random() * 10000).toString();
         //             // node.setDataValue(field, newData[field]);
         //         });
         //     }
         //     else {
         //         ["matchPrice", "changePrice"].forEach(field => {
         //             newData[field] = Math.floor(Math.random() * 10000).toString();
         //             // node.setDataValue(field, newData[field]);
         //         });
         //     }

         //     node.setData(newData);
         // }

         // var pinnedCount = refGrid?.current?.api.getPinnedTopRowCount();
         // for (let i = 0; i < pinnedCount; i++) {
         //     var node = refGrid?.current?.api.getPinnedTopRow(i);
         //     if (!node) {
         //         continue;
         //     }

         //     //
         //     var time1 = (new Date()).getTime();
         //     var newData1 = { ...node.data };

         //     if (time1 % 3 === 0) {
         //         ["bidPrice3", "bidQtty3", "bidPrice2", "bidQtty2", "bidPrice1", "bidQtty1"].forEach(field => {
         //             newData1[field] = Math.floor(Math.random() * 10000).toString();
         //             // node.setDataValue(field, newData[field]);
         //         });
         //     }
         //     else if (time1 % 3 === 1) {
         //         ["offerPrice3", "offerQtty3", "offerPrice2", "offerQtty2", "offerPrice1", "offerQtty1"].forEach(field => {
         //             newData1[field] = Math.floor(Math.random() * 10000).toString();
         //             // node.setDataValue(field, newData[field]);
         //         });
         //     }
         //     else {
         //         ["matchPrice", "changePrice"].forEach(field => {
         //             newData1[field] = Math.floor(Math.random() * 10000).toString();
         //             // node.setDataValue(field, newData[field]);
         //         });
         //     }

         //     node.setData(newData1);
         // }
      }, 100);

      return () => clearInterval(intervalId);
   }, []);

   //
   useEffect(() => {
      window.fnOnClick = function (event) {
         event.stopPropagation();
         event.preventDefault();
         if (!priceFlag.current) {
            priceFlag.current = true;
            refGrid?.current?.columnApi?.setColumnVisible("changePrice", true);
            refGrid?.current?.columnApi?.setColumnVisible("pctChangePrice", false);
         } else {
            priceFlag.current = false;
            refGrid?.current?.columnApi?.setColumnVisible("changePrice", false);
            refGrid?.current?.columnApi?.setColumnVisible("pctChangePrice", true);
         }
      };

      window.fnOnClickVol = function (event) {
         event.stopPropagation();
         event.preventDefault();

         if (!totalVolFlag.current) {
            totalVolFlag.current = true;
            refGrid?.current?.columnApi?.setColumnVisible("totalTradedQttyNM", true);
            refGrid?.current?.columnApi?.setColumnVisible("totalTradedValueNM", false);
         } else {
            totalVolFlag.current = false;
            refGrid?.current?.columnApi?.setColumnVisible("totalTradedQttyNM", false);
            refGrid?.current?.columnApi?.setColumnVisible("totalTradedValueNM", true);
         }
      };
   }, []);

   useEffect(() => {
      setPinnedRows(symbolInfos.filter((e) => pinnedCodesByTab.includes(e.code)).map((e) => ({ ...e })));
   }, [symbolInfos, tabName]);

   const symbolInfos1 = useMemo(() => {
      if (symbolInfos && symbolInfos.length > 0) {
         let tempSymbols = [];
         // B1: Lấy Code đã đc order lên trước
         [...new Set(orderedCodesByTab)].forEach((code) => {
            var symbolInfo = symbolInfos.find((e) => e.code == code);
            if (symbolInfo && symbolInfo.code) {
               tempSymbols.push({ ...symbolInfo });
            }
         });

         // B2: Lấy những mã chưa đc lưu lần order trước
         symbolInfos
            .filter((e) => !orderedCodesByTab.includes(e.code))
            ?.map((e) => {
               tempSymbols.push({ ...e });
            });

         // B3: Bỏ khỏi danh sách những bản ghi được Pin
         var pinnedCodes = pinnedRows.map((e) => e.code);
         return tempSymbols.filter((e) => !pinnedCodes.includes(e.code));
      }

      return [];
   }, [pinnedRows, pinnedRows.length, symbolInfos, symbolInfos.length]);

   //
   const _numberComparator = (valueA, valueB, nodeA, nodeB, isDescending) => {
      if (Number(valueA) == Number(valueB)) return 0;
      return Number(valueA) > Number(valueB) ? 1 : -1;
   };

   //
   const _changePinSymbol = (params) => {
      if (params.event.target.classList.contains("ag-icon-grip") || params.event.target.classList.contains("ag-row-drag")) {
         const isAdd = pinnedRows.findIndex((e) => e.code === params.data.code) < 0;

         var newPinnedRows = [];
         if (isAdd) {
            newPinnedRows = [...pinnedRows, params.data];
         } else {
            newPinnedRows = [...pinnedRows.filter((e) => e.code !== params.data.code)];
         }

         setPinnedRows(newPinnedRows);
         savePinnedCodesByTab(
            window.location.pathname,
            newPinnedRows.map((e) => e.code)
         );
      }
   };

   const _onSortChanged = (params) => {
      // saveOrderedCodesByTab(window.location.pathname, []);
   };

   const _onRowDragEnd = (params) => {
      let orderedCodes = [];
      params.api.forEachNode((n) => orderedCodes.push(n.data.code));
      saveOrderedCodesByTab(window.location.pathname, orderedCodes);
   };

   //
   const _removeFavSymbol = (code) => {
      if (tabIsFav) {
         removeFavSymbol(dispatch, code);
         handleRemoveStockIntoCategory(code);
      } else {
         removeSummarySymbol(dispatch, code);
      }
   };

   const getCategoryStock = async () => {
      const { data: loaded } = await apiCategoryStock.CategoryStock();
      dispatch({
         type: "GET_CATEGORY_STOCK",
         payload: loaded.arrCata,
      });
   };

   const handleRemoveStockIntoCategory = async (code) => {
      await apiCategoryStock
         .EditGroupStock({ lstid: currentCategory, code: code, type: "D" })
         .then((res) => {
            if (res.status === 200) {
               // setSearchValue("");
            }
         })
         .catch((err) => {
            console.log("err => ", err);
         })
         .finally(() => {
            getCategoryStock();
         });
   };
   const calculateCodeMinWidth = useMemo(() => {
      if (!symbolInfos || symbolInfos.length === 0) return 90;

      const codeContentWidths = symbolInfos.map((item) => {
         const codeWidth = (item.code || "").length * 9;
         const randomEndBadgeWidth = 22;

         // Reserve room for cell padding, the pin/drag icon and the optional RE badge.
         return codeWidth + 32 + randomEndBadgeWidth;
      });

      return Math.max(90, ...codeContentWidths);
   }, [symbolInfos, tabName]);

   const referenceStatusMap = {
      1: "Trả CT bằng tiền",
      2: "Trả cổ tức bằng CP/CP thưởng",
      3: "Phát hành CP cho cổ đông hiện hữu",
      4: "Trả cổ tức bằng CP/CP thưởng, phát hành CP cho cổ đông hiện hữu",
      5: "Trả cổ tức bằng tiền, bằng CP/CP thưởng, phát hành CP cho cổ đông hiện hữu",
      6: "Niêm yết bổ sung",
      7: "Giảm vốn",
      8: "Trả cổ tức bằng tiền, trả cổ tức bằng CP/CP thưởng",
      9: "Trả cổ tức bằng tiền, phát hành CP cho cổ đông hiện hữu",
      10: "Thay đổi tỷ lệ Free Float",
      11: "Họp đại cổ đông",
      15: "Chia tách cổ phiếu",
   };
   const CustomTooltip = (props) => {
      // AG Grid will pass the value returned by tooltipValueGetter into props.value
      const text = props.value ?? "";

      // style: pre-line will convert '\n' thành xuống dòng
      const style = {
         whiteSpace: "pre-line",
         padding: "6px 8px",
         maxWidth: 520,
         borderRadius: 6,
         boxShadow: "0 2px 6px rgba(0,0,0,0.5)",
         background: "#222", // tuỳ chỉnh theme tooltip
         color: "#fff",
         fontSize: 13,
         lineHeight: "1.3",
      };

      return <div style={style}>{text}</div>;
   };
   const tooltipValueGetter = (params) => {
      // Build lines array then join bằng '\n'
      const lines = [];

      lines.push(`${params.data.code} - ${params.data.symbolName ?? ""} - ${params.data.marketName}`);

      if (params?.data?.referenceStatus) {
         const statusText = referenceStatusMap[params.data.referenceStatus];
         if (statusText) {
            // thêm dòng mới - component sẽ hiển thị xuống dòng nhờ pre-line
            lines.push(statusText);
         }
      }
      lines.push(params.node?.rowPinned ? t("notePinnedIcon") : t("notePinIcon"));

      // nếu bạn muốn 1 dòng phụ là <div> or html thì đừng chèn tag HTML vì AG Grid đang escape.
      return lines.join("\n");
   };

   //
   return (
      <>
         <div className={`price-board ag-theme-alpine-dark${isAutoScroll ? " auto-scroll" : ""}`}>
            {/* <TableBody symbolInfos={symbolInfos} tabName={tabName} /> */}

            <AgGridReact
               ref={refGrid}
               // containerStyle={{
               //     border: "1px solid #999",
               //     borderRadius: "8px 8px 0 0",
               // }}
               getRowId={(params) => {
                  return params.data.code;
               }}
               alwaysShowHorizontalScroll={false}
               alwaysShowVerticalScroll={false}
               domLayout="normal"
               rowData={symbolInfos1}
               defaultColDef={{
                  editable: false,
                  flex: 1,
                  minWidth: 60,
                  filter: false,
                  sortable: true,
                  cellStyle: { textAlign: "right" },
                  wrapHeaderText: true,
                  // enableCellChangeFlash: true,
               }}
               onGridReady={(params) => {
                  // console.log("onGridReady", params);
               }}
               onComponentStateChanged={(params) => {
                  // console.log("onComponentStateChanged", params);
               }}
               onSortChanged={(params) => {
                  // console.log("onSortChanged", params);
                  _onSortChanged(params);
               }}
               rowDragManaged={true}
               // rowDragEntireRow={true}
               onRowDragEnd={(params) => {
                  // console.log("onRowDragEnd", params);
                  _onRowDragEnd(params);
               }}
               animateRows={true}
               // cellFlashDuration={300}
               // cellFadeDuration={0}
               cellFlashDelay={300}
               cellFadeDelay={0}
               onCellClicked={(params) => {
                  // console.log("onCellClicked", params);
                  if (params.value == params.data.code) {
                     _changePinSymbol(params);
                  }
               }}
               cellSelection={false}
               suppressMovableColumns={true}
               suppressColumnMoveAnimation={true}
               pinnedTopRowData={pinnedRows}
               tooltipShowDelay={0}
               columnDefs={[
                  {
                     headerName: t("maCK"),
                     flex: 1,
                     field: "code",
                     rowDrag: true,
                     cellRenderer: (params) => {
                        return (
                           <CodeCellRenderer
                              cellParams={params}
                              value={params.value}
                              colorClass={params.data.matchPrice_color}
                              showPinIcon={true}
                              showRemoveIcon={showRemoveIcon}
                              removeFavSymbol={_removeFavSymbol}
                              referenceStatus={params?.data?.referenceStatus}
                              isRandomEnd={params?.data?.isRandomEnd}
                           />
                        );
                     },
                     tooltipValueGetter: tooltipValueGetter,
                     tooltipComponent: CustomTooltip,
                     cellStyle: { textAlign: "left" },
                     minWidth: calculateCodeMinWidth,
                     enableCellChangeFlash: false,
                     cellClass: ["cell-ag-icon-remove"],
                  },
                  {
                     headerName: t("tran"),
                     flex: 1,
                     field: "ceilPrice",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                     },
                     comparator: _numberComparator,
                     minWidth: 50,
                  },
                  {
                     headerName: t("san"),
                     flex: 1,
                     field: "floorPrice",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                     },
                     comparator: _numberComparator,
                     minWidth: 50,
                  },
                  {
                     headerName: t("tc"),
                     flex: 1,
                     field: "refPrice",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={"clr-ref"} />;
                     },
                     comparator: _numberComparator,
                     minWidth: 50,
                     cellStyle: { borderRight: "2px solid white" },
                     headerClass: "ct-border-right",
                  },
                  //
                  {
                     headerName: t("muaBid"),
                     children: [
                        configShowHideColumn.includes("colBuyVol4")
                           ? {
                                headerName: t("kl4"),
                                flex: 1,
                                field: "bidQtty4",
                                cellRenderer: (params) => {
                                   return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                                },
                                comparator: _numberComparator,
                             }
                           : { hide: true },
                        isAutoScroll
                           ? { hide: true }
                           : {
                                headerName: t("gia3"),
                                flex: 1,
                                field: "bidPrice3",
                                cellRenderer: (params) => {
                                   return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                                },
                                comparator: _numberComparator,
                                minWidth: 50,
                             },
                        isAutoScroll
                           ? { hide: true }
                           : {
                                headerName: t("kl3"),
                                flex: 1,
                                field: "bidQtty3",
                                cellRenderer: (params) => {
                                   return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                                },
                                comparator: _numberComparator,
                             },
                        {
                           headerName: t("gia2"),
                           flex: 1,
                           field: "bidPrice2",
                           cellRenderer: (params) => {
                              return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                           },
                           comparator: _numberComparator,
                           minWidth: 50,
                        },
                        {
                           headerName: t("kl2"),
                           flex: 1,
                           field: "bidQtty2",
                           cellRenderer: (params) => {
                              return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                           },
                           comparator: _numberComparator,
                        },
                        {
                           headerName: t("gia1"),
                           flex: 1,
                           field: "bidPrice1",
                           cellRenderer: (params) => {
                              return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                           },
                           comparator: _numberComparator,
                           minWidth: 50,
                        },
                        {
                           headerName: t("kl1"),
                           flex: 1,
                           field: "bidQtty1",
                           cellRenderer: (params) => {
                              return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                           },
                           comparator: _numberComparator,
                           cellStyle: { borderRight: "2px solid white" },
                           headerClass: "ct-border-right",
                        },
                     ],
                     headerClass: "justify-content-center ct-border-right",
                  },
                  //
                  configShowHideColumn.includes("colSubSymbol")
                     ? {
                          headerName: "",
                          flex: 1,
                          field: "code",
                          cellRenderer: (params) => {
                             return (
                                <CodeCellRenderer
                                   cellParams={params}
                                   value={params.value}
                                   colorClass={params.data.matchPrice_color}
                                   referenceStatus={params?.data?.referenceStatus}
                                />
                             );
                          },
                          tooltipValueGetter: (params) => {
                             const lines = [];

                             lines.push(`${params.data.code} - ${params.data.symbolName ?? ""} - ${params.data.marketName}`);

                             if (params?.data?.referenceStatus) {
                                const statusText = referenceStatusMap[params.data.referenceStatus];
                                if (statusText) {
                                   lines.push(statusText);
                                }
                             }

                             return lines.join("\n");
                          },
                          tooltipComponent: CustomTooltip,
                          cellStyle: { textAlign: "left" },
                          minWidth: tabName !== "CW" ? (calculateCodeMinWidth - 40) : calculateCodeMinWidth,
                          enableCellChangeFlash: false,
                       }
                     : {
                          hide: true,
                       },
                  {
                     headerName: t("giaKhop"),
                     flex: 1,
                     field: "matchPrice",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                     },
                     comparator: _numberComparator,
                  },
                  {
                     headerName: "+/-",
                     flex: 1.2,
                     // minWidth: 90,
                     field: "changePrice",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                     },
                     comparator: _numberComparator,
                     headerComponentParams: {
                        template: `<div class="ag-cell-label-container" role="presentation">
                                        <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
                                        <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                            <button ref="eTest" class="btn-switch-col" onclick="fnOnClick(event)" ontouchstart="fnOnClick(event)"><img className="imgcaret" src="/static/img/icon/caret-left-fill.svg" alt="img" /></button>
                                            <span ref="eText" class="ag-header-cell-text"></span>
                                            <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
                                            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
                                            <button ref="eTest" class="btn-switch-col" onclick="fnOnClick(event)" ontouchstart="fnOnClick(event)"><img className="imgcaret" src="/static/img/icon/caret-right-fill.svg" alt="img" /></button>
                                        </div>
                                    </div>`,
                     },
                     hide: !priceFlag.current ? true : false,
                  },
                  {
                     headerName: "%",
                     flex: 1.2,
                     // minWidth: 90,
                     field: "pctChangePrice",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                     },
                     comparator: _numberComparator,
                     headerComponentParams: {
                        template: `<div class="ag-cell-label-container" role="presentation">
                                        <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
                                        <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                            <button ref="eTest" class="btn-switch-col" onclick="fnOnClick(event)" ontouchstart="fnOnClick(event)"><img className="imgcaret" src="/static/img/icon/caret-left-fill.svg" alt="img" /></button>
                                            <span ref="eText" class="ag-header-cell-text"></span>
                                            <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
                                            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
                                            <button ref="eTest" class="btn-switch-col" onclick="fnOnClick(event)" ontouchstart="fnOnClick(event)"><img className="imgcaret" src="/static/img/icon/caret-right-fill.svg" alt="img" /></button>
                                        </div>
                                    </div>`,
                     },
                     hide: priceFlag.current ? true : false,
                  },
                  {
                     headerName: t("klKhop"),
                     flex: 1,
                     field: "matchQtty",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                     },
                     comparator: _numberComparator,
                  },
                  configShowHideColumn.includes("colTotalBuy")
                     ? {
                          headerName: t("tongKLKhop"),
                          flex: 1.6,
                          field: "totalTradedQttyNM",
                          cellRenderer: (params) => {
                             return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                          },
                          minWidth: 120,
                          comparator: _numberComparator,
                          headerComponentParams: {
                             template: `<div class="ag-cell-label-container" role="presentation">
                                        <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
                                        <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                            <button ref="eTest" class="btn-switch-col" onclick="fnOnClickVol(event)" ontouchstart="fnOnClickVol(event)"><img className="imgcaret" src="/static/img/icon/caret-left-fill.svg" alt="img" /></button>
                                            <span ref="eText" class="ag-header-cell-text"></span>
                                            <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
                                            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
                                            <button ref="eTest" class="btn-switch-col" onclick="fnOnClickVol(event)" ontouchstart="fnOnClickVol(event)"><img className="imgcaret" src="/static/img/icon/caret-right-fill.svg" alt="img" /></button>
                                        </div>
                                    </div>`,
                          },
                          hide: !totalVolFlag.current ? true : false,
                       }
                     : { hide: true },
                  configShowHideColumn.includes("colTotalBuy")
                     ? {
                          headerName: t("tongGTKhop"),
                          flex: 1.6,
                          minWidth: 120,
                          field: "totalTradedValueNM",
                          cellRenderer: (params) => {
                             return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                          },
                          comparator: _numberComparator,
                          headerComponentParams: {
                             template: `<div class="ag-cell-label-container" role="presentation">
                                        <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
                                        <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                                            <button ref="eTest" class="btn-switch-col" onclick="fnOnClickVol(event)" ontouchstart="fnOnClickVol(event)"><img className="imgcaret" src="/static/img/icon/caret-left-fill.svg" alt="img" /></button>
                                            <span ref="eText" class="ag-header-cell-text"></span>
                                            <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
                                            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
                                            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
                                            <button ref="eTest" class="btn-switch-col" onclick="fnOnClickVol(event)" ontouchstart="fnOnClickVol(event)"><img className="imgcaret" src="/static/img/icon/caret-right-fill.svg" alt="img" /></button>
                                        </div>
                                    </div>`,
                          },
                          hide: totalVolFlag.current ? true : false,
                       }
                     : { hide: true },
                  //
                  {
                     headerName: t("banAsk"),
                     children: [
                        {
                           headerName: t("gia1"),
                           flex: 1,
                           field: "offerPrice1",
                           cellRenderer: (params) => {
                              return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                           },
                           comparator: _numberComparator,
                           minWidth: 50,
                           cellStyle: { borderLeft: "2px solid white" },
                           headerClass: "ct-border-left",
                        },
                        {
                           headerName: t("kl1"),
                           flex: 1,
                           field: "offerQtty1",
                           cellRenderer: (params) => {
                              return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                           },
                           comparator: _numberComparator,
                        },
                        {
                           headerName: t("gia2"),
                           flex: 1,
                           field: "offerPrice2",
                           cellRenderer: (params) => {
                              return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                           },
                           comparator: _numberComparator,
                           minWidth: 50,
                        },
                        {
                           headerName: t("kl2"),
                           flex: 1,
                           field: "offerQtty2",
                           cellRenderer: (params) => {
                              return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                           },
                           comparator: _numberComparator,
                        },
                        isAutoScroll
                           ? { hide: true }
                           : {
                                headerName: t("gia3"),
                                flex: 1,
                                field: "offerPrice3",
                                cellRenderer: (params) => {
                                   return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                                },
                                comparator: _numberComparator,
                                minWidth: 50,
                             },
                        isAutoScroll
                           ? { hide: true }
                           : {
                                headerName: t("kl3"),
                                flex: 1,
                                field: "offerQtty3",
                                cellRenderer: (params) => {
                                   return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                                },
                                comparator: _numberComparator,
                             },
                        configShowHideColumn.includes("colSellVol4")
                           ? {
                                headerName: t("kl4"),
                                flex: 1,
                                field: "offerQtty4",
                                cellRenderer: (params) => {
                                   return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                                },
                                comparator: _numberComparator,
                             }
                           : { hide: true },
                     ],
                     headerClass: "ct-border-left justify-content-center",
                  },
                  {
                     headerName: t("giaTB"),
                     flex: 1,
                     field: "avgPrice",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                     },
                     comparator: _numberComparator,
                     minWidth: 50,
                     cellStyle: { borderLeft: "2px solid white" },
                     headerClass: "ct-border-left",
                  },
                  {
                     headerName: t("caoNhat"),
                     flex: 1,
                     field: "highestPrice",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                     },
                     comparator: _numberComparator,
                     minWidth: 50,
                  },
                  {
                     headerName: t("thapNhat"),
                     flex: 1,
                     field: "lowestPrice",
                     cellRenderer: (params) => {
                        return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} />;
                     },
                     comparator: _numberComparator,
                     minWidth: 50,
                  },
                  configShowHideColumn.includes("colNNbuy")
                     ? isAutoScroll
                        ? { hide: true }
                        : {
                             headerName: t("nnMua"),
                             flex: 1,
                             field: "buyForeignQtty",
                             cellRenderer: (params) => {
                                return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                             },
                             comparator: _numberComparator,
                          }
                     : { hide: true },
                  configShowHideColumn.includes("colNNsell")
                     ? isAutoScroll
                        ? { hide: true }
                        : {
                             headerName: t("nnBan"),
                             flex: 1,
                             field: "sellForeignQtty",
                             cellRenderer: (params) => {
                                return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                             },
                             comparator: _numberComparator,
                          }
                     : { hide: true },
                  configShowHideColumn.includes("colRoom")
                     ? isAutoScroll
                        ? { hide: true }
                        : {
                             headerName: t("Room"),
                             flex: 1.5,
                             minWidth: 120,
                             field: "remainForeignQtty",
                             cellRenderer: (params) => {
                                return <CellRenderer cellParams={params} value={params.value} colorClass={params.data[params.colDef.field + "_color"]} isQtty={true} />;
                             },
                             comparator: _numberComparator,
                          }
                     : { hide: true },
               ]}
            />
         </div>
      </>
   );
});

//
const CellRenderer = memo(
   function (props) {
      const { cellParams, value, colorClass, isQtty } = props;
      const code = cellParams.data.code;
      const field = cellParams.colDef.field;

      const tagId = code + "_" + field;
      const prevValue = useRef(value);

      const fieldInfo = {
         value: value ?? "",
         colorClass: colorClass ?? "",
      };

      let displayValue = fieldInfo?.value ?? "";
      if (isQtty) {
         displayValue = formatQtty(fieldInfo?.value ?? "");
      } else if (field == "totalTradedValueNM") {
         displayValue = formatNumberToM(fieldInfo?.value ?? "");
      } else if (field == "changePrice" || field == "pctChangePrice") {
         displayValue = formatPctChangePrice(fieldInfo?.value);
      }

      if (field == "pctChangePrice" && !isNullOrEmpty(displayValue)) {
         displayValue += "%";
      }

      //
      useLayoutEffect(() => {
         let _timerId = -1;
         const _el = document.getElementById(tagId).parentElement;

         if (prevValue.current !== value) {
            prevValue.current = value;
            if (_el) {
               _el.classList.remove("active_change");
               _el.classList.add("active_change");
               _timerId = setTimeout(() => {
                  _el.classList.remove("active_change");
               }, 300);
            }
         }

         return () => {
            clearTimeout(_timerId);
            // try {
            //     if (_el) {
            //         _el.classList.remove("active_change");
            //     }
            // }
            // catch (error) {
            // }
         };
      });

      //
      return (
         <span className={fieldInfo?.colorClass ?? ""} id={tagId}>
            {displayValue}
         </span>
      );
   },
   (prevProps, nextProps) => {
      if (prevProps.value === nextProps.value && prevProps.colorClass === nextProps.colorClass) {
         return true;
      }
      return false;
   }
);

const CodeCellRenderer = memo(function (props) {
   const { cellParams, value, colorClass, showPinIcon, showRemoveIcon, removeFavSymbol, referenceStatus, isRandomEnd } = props;
   const code = cellParams.data.code;
   const field = cellParams.colDef.field;

   const dispatch = useDispatch();

   const fieldInfo = { value: referenceStatus !== "0" && referenceStatus !== "" ? value + "*" : value ?? "", colorClass: colorClass ?? "" };

   const _onClickCode = (code) => {
      showPopupInfo(dispatch, "ST", code);
   };

   const _onRemoveCode = (code) => {
      if (removeFavSymbol) {
         removeFavSymbol(code);
      }
   };

   const _getRemoveIcon = () => {
      return (
         showRemoveIcon && (
            <svg onClick={() => _onRemoveCode(code)} className="ag-grid-icon-remove" width="12" height="12" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
               <line x1="2" y1="2" x2="14" y2="14" stroke="darkgray" strokeWidth="3" />
               <line x1="2" y1="14" x2="14" y2="2" stroke="darkgray" strokeWidth="3" />
            </svg>
         )
      );
   };

   const _getCodeValue = () => {
      return (
         <span className={`ag-grid-symbol-code ${fieldInfo?.colorClass ?? ""}`}>
            <span id={code + "_code"} onClick={() => _onClickCode(code)} style={{ fontWeight: "bold", cursor: "pointer" }}>
               {fieldInfo?.value ?? ""}
            </span>
            {isRandomEnd === "Y" && <RandomEndIcon className="ag-grid-icon-random-end" role="img" aria-label="RE" />}
         </span>
      );
   };

   if (showPinIcon) {
      if (cellParams?.node?.rowPinned) {
         return (
            <span className="ag-cell-value">
               <span className={"ag-icon ag-icon-grip ag-icon-grip-checked"} style={{ marginRight: 5, cursor: "grab" }}></span>
               {_getCodeValue()}
               {_getRemoveIcon()}
            </span>
         );
      } else {
         return (
            <>
               {_getCodeValue()}
               {_getRemoveIcon()}
            </>
         );
      }
   }
   return _getCodeValue();
});
